module.exports = __webpack_public_path__ + "static/media/display-suite-13.59934215.jpg";